enum RoutePathEnum {
    Flight = '/flight',
    Train = '/train',
    Transfer = '/transfer',
    Options = '/options-v1',
    OptionsV2 = '/options',
    UserInfo = '/user-info-v1',
    UserInfoV2 = '/user-info',
    Payment = '/payment-v1',
    PaymentV2 = '/payment',
    Success = '/success',
    Paid = '/paid',
    Error = '/error',
    NewPassword = '/new-password',
    BalancePayment = '/balance-payment/:boReference',
}

export default RoutePathEnum